module.exports = __webpack_public_path__ + "bb358f71a7f8a1e0802a9785b68952c9.svg";